import Chart from 'chart.js/auto';

const ch4 = [
	[ [ 0.226, 0, 0, 0.111 ], [ 7.002783036, 4.304267135, 9.15223117, 1.626752696 ] ],
	[ [ 0.23, 0.146, 0.105, 0 ], [ 7.093571062, 4.360070079, 9.270885853, 1.647842835 ] ],
	[ [ 0.14, 0.114, 0.145, 0 ], [ 7.141991342, 4.38983165, 9.33416835, 1.659090909 ] ],
	[ [ 0, 0.145, 0.211, 0 ], [ 7.214621762, 4.434474006, 9.429092096, 1.67596302 ] ],
	[ [ 0.104, 0, 0.237, 0 ], [ 7.365935138, 4.5274789129999995, 9.6268499, 1.711113251 ] ],
	[ [ 0, 0.131, 0.219, 0 ], [ 6.86357473, 4.218702619, 8.970293991, 1.594414484 ] ],
	[ [ 0, 0, 0.174, 0 ], [ 7.583317948, 4.66109346, 9.9109566201, 1.76161147 ] ]
];

var ch4GWP20 = [[[],[]],[[],[]],[[],[]],[[],[]],[[],[]],[[],[]],[[],[]]]
var ch4GWP100 = [[[],[]],[[],[]],[[],[]],[[],[]],[[],[]],[[],[]],[[],[]]]

for (let i = 0; i < 7; i++) {
    for (let j = 0; j < 2; j++) {
        for (let k = 0; k < 4; k++) {
            var tmp = ch4[i][j][k]
            ch4GWP20[i][j][k] = tmp * 0.0825 
            ch4GWP100[i][j][k] = tmp * 0.0298
        }
    }
}

const co2 = [
	[ [ 2.34, 2.33, 4.25, 0.116 ], [ 4.296486265, 2.601792113, 5.53223165, 0.6363856549 ] ],
	[ [ 2.29, 2.5, 4.28, 0 ], [ 4.352188334, 2.635523212, 5.603954619, 0.6446361171 ] ],
	[ [ 2.07, 2.54, 3.83, 0.117 ], [ 4.381896104, 2.653513131, 5.642206869, 0.6490363636 ] ],
	[ [ 2.25, 2.01, 4.21, 0.102 ], [ 4.426457759, 2.680498011, 5.699585244, 0.6556367334 ] ],
	[ [ 2.15, 2.83, 4.38, 0.108 ], [ 4.519294541, 2.736716509, 5.819123525, 0.6693875039 ] ],
	[ [ 2.03, 2.73, 4.17, 0.129 ], [ 4.211076425, 2.550071094, 5.422256431, 0.6237349461 ] ],
	[ [ 2.12, 2.38, 4.39, 0.119 ], [ 4.652667551, 2.817482238, 5.99085697, 0.6891424071 ] ]
];

const ch4CTcolor = '#FF761A';
const ch4EEAcolor = '#6D5337';
const co2CTcolor = '#afcc0a';
const co2EEAcolor = '#535f0d';

var data = ch4;

const thisChart = document.getElementById('bar-chart-grouped');

Chart.defaults.font.size = 14;
Chart.defaults.color = '#000000';

let chartObj = new Chart(thisChart, {
	type: 'bar',
	data: {
		labels: [ 'BP', 'ExxonMobil', 'Shell', 'Vitol' ],
		datasets: [
			{
				label: 'Europees Milieuagentschap',
				backgroundColor: ch4EEAcolor,
				data: data[4][0]
			},
			{
				label: 'Climate TRACE',
				backgroundColor: ch4CTcolor,
				data: data[4][1]
			}
		]
	},

	options: {
		title: {
			display: true,
			text: ''
		},
		maintainAspectRatio: false,
		scales: {
			y: {
				title: {
				  display: true,
				  text: 'Kiloton'
				}
			}
		}
	}, 
	plugins: [{
		beforeInit: function(chart, options) {
		  chart.legend.afterFit = function() {
			this.height = 50;
		  };
		}
	  }]
	
});

var slider = document.getElementById('myRange');
var output = document.getElementById('yearLegend');
var output2 = document.getElementById('slidervalue');
var year = 2021

// Update the current slider value (each time you drag the slider handle)
slider.oninput = function() {
    year = this.value
	output.innerHTML = 'Selecteer jaar: <b>' + this.value + '</b>';
	output2.innerHTML = 'Methaanemissies Rotterdamse raffinaderijen (' + this.value + ')';
	chartObj.data.datasets[0].data = data[this.value - 2015][0];
	chartObj.data.datasets[1].data = data[this.value - 2015][1];
	chartObj.update();
};


var radio1 = document.getElementById("op1")
radio1.addEventListener('change', function() {
    if (this.checked) {

			data = ch4;
            console.log(data)
            chartObj.data.datasets[0].data = data[year - 2015][0];
            chartObj.data.datasets[1].data = data[year - 2015][1];
			chartObj.data.datasets[0].backgroundColor = ch4EEAcolor;
			chartObj.data.datasets[1].backgroundColor = ch4CTcolor;
			chartObj.options.scales.y.title.text = "Kiloton"
            chartObj.update();

    }
})


var radio2 = document.getElementById("op2")
radio2.addEventListener('change', function() {
    if (this.checked) {

			data = ch4GWP20;
            console.log(data)
            chartObj.data.datasets[0].data = data[year - 2015][0];
            chartObj.data.datasets[1].data = data[year - 2015][1];
			chartObj.data.datasets[0].backgroundColor = ch4EEAcolor;
			chartObj.data.datasets[1].backgroundColor = ch4CTcolor;
			chartObj.options.scales.y.title.text = "Megaton CO₂-eq, GWP 20"
            chartObj.update();

    }
})


var radio3 = document.getElementById("op3")
radio3.addEventListener('change', function() {
    if (this.checked) {

			data = ch4GWP100;
            console.log(data)
            chartObj.data.datasets[0].data = data[year - 2015][0];
            chartObj.data.datasets[1].data = data[year - 2015][1];
			chartObj.data.datasets[0].backgroundColor = ch4EEAcolor;
			chartObj.data.datasets[1].backgroundColor = ch4CTcolor;
			chartObj.options.scales.y.title.text = "Megaton CO₂-eq, GWP 100"
            chartObj.update();

    }
})


var radio4 = document.getElementById("op4")
radio4.addEventListener('change', function() {
    if (this.checked) {

        data = co2;
        console.log(data)
        chartObj.data.datasets[0].data = data[year - 2015][0];
        chartObj.data.datasets[1].data = data[year - 2015][1];
        chartObj.data.datasets[0].backgroundColor = co2EEAcolor;
        chartObj.data.datasets[1].backgroundColor = co2CTcolor;
		chartObj.options.scales.y.title.text = "CO₂ (Mton)"
        chartObj.update();

    }
})



function handleChange(src) {
	switch (src.value) {
		case 'op1':
			data = ch4;
			CTcolor = ch4CTcolor;
			EEAcolor = ch4EEAcolor;
			break;
		case 'op2':
			data = ch4GWP20;
			CTcolor = ch4CTcolor;
			EEAcolor = ch4EEAcolor;
			break;
		case 'op3':
			data = ch4GWP100;
			CTcolor = ch4CTcolor;
			EEAcolor = ch4EEAcolor;
			break;
		case 'op4':
			data = co2;
			CTcolor = ch4CTcolor;
			EEAcolor = ch4EEAcolor;
			break;
	}
}
